/**
 * Notifications
 *
 * Composed wrapper for all notification UI components.
 * Drop this into the Header for full notification support.
 */

import { useState } from "react";
import { NotificationBell } from "./NotificationBell";
import { NotificationPanel } from "./NotificationPanel";
import { NotificationToast } from "./NotificationToast";
import { NotificationPreferencesModal } from "./NotificationPreferencesModal";
import { useNotificationAlerts } from "@/hooks/useNotificationAlerts";

export function Notifications() {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);

  // Sound + desktop notification alerts
  useNotificationAlerts();

  return (
    <div className="relative">
      <NotificationBell />
      <NotificationPanel onOpenPreferences={() => setIsPreferencesOpen(true)} />
      <NotificationToast />
      <NotificationPreferencesModal
        open={isPreferencesOpen}
        onOpenChange={setIsPreferencesOpen}
      />
    </div>
  );
}
